import { useMemo } from 'react';
import { ApolloClient, InMemoryCache, NormalizedCacheObject } from '@apollo/client';
import { ApolloLinks } from './links.apollo';

interface IParams {
  token: string;
  refresh_token: string;
}

function createApolloClient(params: IParams) {
  const links = new ApolloLinks(params.token, params.refresh_token);

  return new ApolloClient({
    link: links.concat(),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'network-only',
      },
    },
  });
}

export function useApollo(params: IParams) {
  return useMemo(() => createApolloClient(params), [params]);
}
